import { render, staticRenderFns } from "./SiretItem.vue?vue&type=template&id=08af9d89"
import script from "./SiretItem.vue?vue&type=script&lang=js"
export * from "./SiretItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports